import "./appglobals"
import { createApp } from "vue"
import Vuelidate from "@vuelidate/core"
import NProgress from "nprogress"
import App from "./App.vue"
import router from "./router"
import i18n from "./content"

NProgress.configure({ showSpinner: true })

createApp(App)
  .use(router)
  .use(i18n)
  .use(Vuelidate)
  .mount("#app")
